/* Nova maquette: reveal on scroll, hero slider, product tabs, product rows. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;

  function initReveal(root) {
    var items = root.querySelectorAll('[data-nv-reveal]:not(.nv-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('nv-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nv-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }

  function initSlider(slider) {
    if (slider.dataset.nvReady) return;
    slider.dataset.nvReady = '1';
    var slides = slider.querySelectorAll('.nv-hero__slide');
    var dots = slider.querySelectorAll('.nv-hero__dot');
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var delay = (parseInt(slider.dataset.autoplay, 10) || 6) * 1000;

    function go(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function play() {
      stop();
      if (!reduceMotion) timer = setInterval(function () { go(current + 1); }, delay);
      slider.classList.remove('is-paused');
      var dot = dots[current];
      if (dot) {
        dot.classList.remove('is-active');
        void dot.offsetWidth;
        dot.classList.add('is-active');
      }
    }
    function stop() {
      clearInterval(timer);
      slider.classList.add('is-paused');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); play(); });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);

    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });
    play();
  }

  function initTabs(section) {
    if (section.dataset.nvReady) return;
    section.dataset.nvReady = '1';
    var tabs = section.querySelectorAll('[data-nv-tab]');
    var panels = section.querySelectorAll('[data-nv-panel]');
    var ink = section.querySelector('.nv-tabs__ink');

    function moveInk(tab) {
      if (!ink || !tab) return;
      ink.style.width = tab.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }
    function select(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      panels.forEach(function (panel) {
        var active = panel.dataset.nvPanel === tab.dataset.nvTab;
        panel.hidden = !active;
        if (active) {
          panel.querySelectorAll('[data-nv-reveal]').forEach(function (el) { el.classList.add('nv-in'); });
          panel.classList.remove('nv-swap');
          void panel.offsetWidth;
          panel.classList.add('nv-swap');
        }
      });
      moveInk(tab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab); });
    });
    var first = section.querySelector('[data-nv-tab][aria-selected="true"]') || tabs[0];
    requestAnimationFrame(function () { moveInk(first); });
    window.addEventListener('resize', function () {
      moveInk(section.querySelector('[data-nv-tab][aria-selected="true"]'));
    });
  }

  function initRow(row) {
    if (row.dataset.nvReady) return;
    row.dataset.nvReady = '1';
    var track = row.querySelector('[data-nv-row-track]');
    var prev = row.querySelector('[data-nv-row-prev]');
    var next = row.querySelector('[data-nv-row-next]');
    if (!track) return;

    function step() { return Math.max(track.clientWidth * 0.8, 240); }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      row.classList.toggle('nv-row--static', max <= 0);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Cart: one event after every cart request, whatever the theme uses ---------- */

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?/;
  var cartPromise = null;
  var lastAtcButton = null;

  function emitCartChanged(url) {
    cartPromise = null;
    document.dispatchEvent(new CustomEvent('nv:cart-changed', { detail: { added: /\/cart\/add/.test(url) } }));
  }

  if (window.fetch && !window.fetch.nvWrapped) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var request = nativeFetch.apply(this, arguments);
      if (CART_URL.test(url)) {
        request.then(function (res) { if (res.ok) emitCartChanged(url); }).catch(function () {});
      }
      return request;
    };
    window.fetch.nvWrapped = true;
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL.test(String(url))) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) emitCartChanged(String(url));
      });
    }
    return nativeOpen.apply(this, arguments);
  };

  function getCart() {
    if (!cartPromise) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cartPromise = fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }
    return cartPromise;
  }

  function money(cents, format) {
    var value = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
    return (format || window.nvMoneyFormat || '{{amount}} dh').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Free-delivery progress (product page and cart drawer) ---------- */

  var SHIP_DEFAULTS = { casa: 39900, maroc: 59900 };

  function renderShip(ship, total, opts) {
    var fill = ship.querySelector('[data-nv-ship-fill]');
    var msg = ship.querySelector('[data-nv-ship-msg]');
    var bar = ship.querySelector('[data-nv-ship-bar]');
    if (fill) fill.style.width = Math.min(100, (total / opts.maroc) * 100) + '%';
    if (bar) bar.setAttribute('aria-valuenow', Math.round(total / 100));
    ship.classList.toggle('is-casa', total >= opts.casa);
    ship.classList.toggle('is-maroc', total >= opts.maroc);

    var html;
    if (total >= opts.maroc) {
      html = '<strong>Livraison offerte partout au Maroc</strong>';
    } else if (total >= opts.casa) {
      html = '<strong>Livraison offerte à Casablanca.</strong> Plus que <strong>' + money(opts.maroc - total, opts.format) + '</strong> pour tout le Maroc';
    } else {
      html = 'Plus que <strong>' + money(opts.casa - total, opts.format) + '</strong> pour la livraison offerte à Casablanca';
    }
    if (opts.projected) html = '<span class="nv-ship__hint">Avec ce produit :</span> ' + html;
    if (msg) msg.innerHTML = html;
  }

  function addBusinessDays(from, days) {
    var date = new Date(from);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) added++;
    }
    return date;
  }

  function initBoost(boost) {
    if (boost.dataset.nvReady) return;
    boost.dataset.nvReady = '1';

    var opts = {
      casa: parseInt(boost.dataset.casa, 10) || SHIP_DEFAULTS.casa,
      maroc: parseInt(boost.dataset.maroc, 10) || SHIP_DEFAULTS.maroc,
      format: boost.dataset.moneyFormat
    };
    var prices = {};
    try { prices = JSON.parse(boost.querySelector('[data-nv-variant-prices]').textContent); } catch (e) {}
    var form = boost.closest('form');
    var ship = boost.querySelector('[data-nv-ship]');

    function variantId() {
      var input = form && form.querySelector('[name="id"]');
      return input ? input.value : Object.keys(prices)[0];
    }
    function quantity() {
      var input = form && form.querySelector('[name="quantity"]');
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    }
    function update() {
      getCart().then(function (cart) {
        var id = String(variantId());
        var inCart = cart.items.some(function (item) { return String(item.variant_id) === id; });
        var total = cart.total_price + (inCart ? 0 : (prices[id] || 0) * quantity());
        renderShip(ship, total, { casa: opts.casa, maroc: opts.maroc, format: opts.format, projected: !inCart });
      }).catch(function () {});
    }

    if (form) {
      form.addEventListener('change', update);
      form.addEventListener('input', update);
      form.addEventListener('click', function () { setTimeout(update, 60); });
    }
    document.addEventListener('nv:cart-changed', update);
    update();

    var eta = boost.querySelector('[data-nv-eta]');
    if (eta) {
      var min = addBusinessDays(new Date(), parseInt(boost.dataset.etaMin, 10) || 1);
      var max = addBusinessDays(new Date(), parseInt(boost.dataset.etaMax, 10) || 2);
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      eta.querySelector('[data-nv-eta-range]').textContent = min.getTime() === max.getTime()
        ? fmt.format(min)
        : fmt.format(min) + ' – ' + fmt.format(max);
      eta.hidden = false;
    }
  }

  function initDrawerShip() {
    var container = document.getElementById('cart-drawer-container');
    if (!container || container.dataset.nvReady) return;
    container.dataset.nvReady = '1';

    var boost = document.querySelector('[data-nv-boost]');
    var opts = {
      casa: boost ? parseInt(boost.dataset.casa, 10) : SHIP_DEFAULTS.casa,
      maroc: boost ? parseInt(boost.dataset.maroc, 10) : SHIP_DEFAULTS.maroc
    };

    function ensureBar() {
      var header = container.querySelector('.scd__header');
      if (!header) return null;
      var ship = container.querySelector('.nv-ship--drawer');
      if (!ship) {
        ship = document.createElement('div');
        ship.className = 'nv-ship nv-ship--drawer';
        ship.style.setProperty('--casa', (opts.casa / opts.maroc) * 100 + '%');
        ship.innerHTML =
          '<p class="nv-ship__msg" data-nv-ship-msg></p>' +
          '<div class="nv-ship__bar" role="progressbar" aria-label="Progression vers la livraison offerte" aria-valuemin="0" aria-valuemax="' + opts.maroc / 100 + '" data-nv-ship-bar>' +
          '<span class="nv-ship__fill" data-nv-ship-fill></span><span class="nv-ship__mark" aria-hidden="true"></span></div>';
        header.insertAdjacentElement('afterend', ship);
      }
      return ship;
    }
    function update() {
      var ship = ensureBar();
      if (!ship) return;
      getCart().then(function (cart) { renderShip(ship, cart.total_price, opts); }).catch(function () {});
    }

    new MutationObserver(function () {
      if (!container.querySelector('.nv-ship--drawer') && container.querySelector('.scd__header')) update();
    }).observe(container, { childList: true, subtree: true });
    document.addEventListener('nv:cart-changed', function () { setTimeout(update, 150); });
    update();
  }

  /* ---------- Product description: plain typography, sections as an accordion ---------- */

  var pictographs = null;
  try {
    pictographs = new RegExp('(?![\\u00A9\\u00AE\\u2122])\\p{Extended_Pictographic}|[\\uFE0F\\u200D\\u20E3]', 'gu');
  } catch (e) {}

  function cleanText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (pictographs) text = text.replace(pictographs, '');
      var trimmed = text.trim();
      if (trimmed.length > 14 && trimmed === trimmed.toUpperCase() && /[A-ZÀ-Ý]{3}/.test(trimmed)) {
        var lower = trimmed.toLowerCase();
        text = text.replace(trimmed, lower.charAt(0).toUpperCase() + lower.slice(1));
      }
      node.nodeValue = text.replace(/^\s+/, node.previousSibling ? ' ' : '').replace(/\s{2,}/g, ' ');
    }
  }

  function initDescription(desc) {
    if (desc.dataset.nvReady) return;
    desc.dataset.nvReady = '1';
    cleanText(desc);

    var root = desc.children.length === 1 && desc.firstElementChild.tagName === 'DIV' ? desc.firstElementChild : desc;
    var children = Array.prototype.slice.call(root.children);
    var isHeading = function (el) { return /^H[2-4]$/.test(el.tagName); };
    if (children.filter(isHeading).length < 2) {
      desc.classList.add('nv-desc--simple');
      return;
    }

    var intro = document.createElement('div');
    intro.className = 'nv-desc__intro';
    var sections = document.createElement('div');
    sections.className = 'nv-desc__sections';
    var body = null;

    children.forEach(function (el) {
      if (isHeading(el)) {
        var details = document.createElement('details');
        details.className = 'nv-acc';
        details.open = !sections.children.length;
        var summary = document.createElement('summary');
        summary.className = 'nv-acc__title';
        summary.textContent = el.textContent.trim();
        body = document.createElement('div');
        body.className = 'nv-acc__body';
        details.appendChild(summary);
        details.appendChild(body);
        sections.appendChild(details);
      } else if (body) {
        body.appendChild(el);
      } else {
        intro.appendChild(el);
      }
    });

    var grid = document.createElement('div');
    grid.className = 'nv-desc__grid';
    if (intro.textContent.trim()) grid.appendChild(intro);
    grid.appendChild(sections);
    desc.innerHTML = '';
    desc.appendChild(grid);
    desc.classList.add('nv-desc--sections');

    // On mobile the theme's accordion caps its height; keep it in sync when a section opens.
    sections.addEventListener('toggle', function () {
      var item = desc.closest('.sf__accordion-item');
      var content = desc.closest('.sf__accordion-content');
      if (item && content && item.style.getPropertyValue('--content-max-height') !== '0px') {
        item.style.setProperty('--content-max-height', content.scrollHeight + 'px');
      }
    }, true);
  }

  /* ---------- Add-to-cart feedback ---------- */

  function bump(el, className) {
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);
  }

  function initCartFeedback() {
    if (document.documentElement.dataset.nvCartFeedback) return;
    document.documentElement.dataset.nvCartFeedback = '1';

    document.addEventListener('click', function (e) {
      var button = e.target.closest('.add-to-cart, button[name="add"]');
      if (button) lastAtcButton = button;
      if (e.target.closest('[data-quantity-input-wrapper] button, .quantity-input__button, [data-quantity-selector]')) {
        var wrapper = e.target.closest('[data-quantity-input-wrapper]') || e.target.parentElement;
        var input = wrapper && wrapper.querySelector('input');
        if (input) setTimeout(function () { bump(input, 'nv-bump'); }, 0);
      }
    }, true);

    document.addEventListener('nv:cart-changed', function (e) {
      if (!e.detail || !e.detail.added) return;
      if (lastAtcButton) {
        var button = lastAtcButton;
        button.classList.add('nv-added');
        setTimeout(function () { button.classList.remove('nv-added'); }, 1800);
      }
      document.querySelectorAll('.cart-icon').forEach(function (icon) { bump(icon, 'nv-bump'); });
    });
  }

  /* Collection filters (Ceramide layout). The theme re-renders the whole section after
     each change, so open groups and the desktop show/hide state are restored here.
     In the drawer (below 1280px) changes wait for "Appliquer". */
  var facetOpen = {};
  var filtersBound = false;
  var applyingFilters = false;

  function inFilterDrawer() {
    return window.innerWidth < 1280;
  }

  function syncFilters(root) {
    root.querySelectorAll('.sf__accordion-item[data-nv-facet]').forEach(function (item) {
      var open = facetOpen[item.dataset.nvFacet];
      if (typeof open === 'boolean') item.classList.toggle('open', open);
    });
    var toggle = root.querySelector('[data-nv-filter-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(!document.documentElement.classList.contains('nv-filters-off')));
    }
  }

  function resetFilterDrawer() {
    var host = document.querySelector('collection-filters-form');
    if (!host || !host.nvPending) return;
    host.nvPending = false;
    var form = host.querySelector('form');
    if (!form) return;
    form.reset();
    form.querySelectorAll('price-range').forEach(function (range) {
      var max = parseFloat(range.dataset.priceMax) || 1;
      var min = range.querySelector('[data-type="min-range"]');
      var top = range.querySelector('[data-type="max-range"]');
      if (min) range.style.setProperty('--from', (min.value / max * 100) + '%');
      if (top) range.style.setProperty('--to', (top.value / max * 100) + '%');
    });
  }

  function applyFilterDrawer() {
    var host = document.querySelector('collection-filters-form');
    if (host && host.nvPending && typeof host.onSubmitHandler === 'function') {
      host.nvPending = false;
      applyingFilters = true;
      try {
        host.onSubmitHandler(new Event('submit'));
      } finally {
        applyingFilters = false;
      }
    }
    var close = document.querySelector('.sf__sidebar-close');
    if (close) close.click();
  }

  function patchFilterForm() {
    if (!window.customElements) return;
    customElements.whenDefined('collection-filters-form').then(function () {
      var proto = customElements.get('collection-filters-form').prototype;
      var submit = proto.onSubmitHandler;
      if (proto.nvPatched || typeof submit !== 'function') return;
      proto.nvPatched = true;
      proto.onSubmitHandler = function (e) {
        // Sorting dispatches "input" on the form itself and should apply right away
        var sorting = e && e.target && e.target.tagName === 'FORM';
        if (inFilterDrawer() && !applyingFilters && !sorting) {
          if (e && e.preventDefault) e.preventDefault();
          this.nvPending = true;
          return;
        }
        return submit.apply(this, arguments);
      };
    });
  }

  function initFilters() {
    var section = document.querySelector('[data-section-type="collection-template"]');
    if (filtersBound || !section || !section.parentNode) return;
    filtersBound = true;
    patchFilterForm();

    document.addEventListener('click', function (e) {
      var head = e.target.closest('[data-nv-facet] > .sf__accordion-button');
      if (head) facetOpen[head.parentNode.dataset.nvFacet] = head.parentNode.classList.contains('open');

      var toggle = e.target.closest('[data-nv-filter-toggle]');
      if (toggle) {
        var off = document.documentElement.classList.toggle('nv-filters-off');
        toggle.setAttribute('aria-expanded', String(!off));
      }

      if (e.target.closest('[data-nv-filter-apply]')) {
        applyFilterDrawer();
      } else if (e.target.closest('.sf__sidebar-close') || e.target.classList.contains('sf__sidebar')) {
        resetFilterDrawer();
      }
    });

    // Runs before the theme re-initialises its accordions (next animation frame)
    var host = section.parentNode;
    new MutationObserver(function () { syncFilters(host); }).observe(host, { childList: true });
  }

  /* Header search, Ceramide-style: Shopify predictive search (queries, collections, products)
     rendered by sections/nv-predictive-search.liquid. Desktop opens a panel under the field,
     phones a full-screen sheet. */
  var searchCache = {};
  var searchBound = false;

  function suggestUrl(term) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'search/suggest?q=' + encodeURIComponent(term) +
      '&resources[type]=query,collection,product&resources[limit]=10&resources[limit_scope]=each' +
      '&section_id=nv-predictive-search';
  }

  function initSearchBox(box) {
    if (box.dataset.nvReady) return;
    box.dataset.nvReady = '1';
    var overlay = box.dataset.mode === 'overlay';
    var input = box.querySelector('[data-nv-search-input]');
    var panel = box.querySelector('[data-nv-search-panel]');
    var results = box.querySelector('[data-nv-search-results]');
    var popular = box.querySelector('[data-nv-search-popular]');
    var clear = box.querySelector('[data-nv-search-clear]');
    var timer = null;
    var controller = null;

    // A fixed sheet inside the (sometimes transformed) header would be positioned wrongly
    if (overlay) document.body.appendChild(box);

    function open() {
      if (overlay) {
        box.hidden = false;
        document.documentElement.classList.add('nv-search-locked');
      } else {
        panel.hidden = false;
        box.classList.add('is-open');
      }
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (overlay) {
        box.hidden = true;
        document.documentElement.classList.remove('nv-search-locked');
      } else {
        panel.hidden = true;
        box.classList.remove('is-open');
      }
      input.setAttribute('aria-expanded', 'false');
    }

    function show(html, term) {
      results.innerHTML = html;
      if (popular) popular.hidden = !!term;
    }

    function search(value) {
      var term = value.trim();
      clear.hidden = !term;
      if (!term) {
        show('', '');
        return;
      }
      if (searchCache[term] !== undefined) {
        show(searchCache[term], term);
        return;
      }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      box.classList.add('is-loading');
      fetch(suggestUrl(term), controller ? { signal: controller.signal } : {})
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var node = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-nv-ps-results]');
          var html = node ? node.outerHTML : '';
          searchCache[term] = html;
          if (input.value.trim() === term) show(html, term);
        })
        .catch(function () {})
        .then(function () { box.classList.remove('is-loading'); });
    }

    input.addEventListener('focus', open);
    input.addEventListener('input', function () {
      open();
      clearTimeout(timer);
      timer = setTimeout(function () { search(input.value); }, 220);
    });

    clear.addEventListener('click', function () {
      input.value = '';
      search('');
      input.focus();
    });

    // Keyboard: arrows move through the options, Escape closes
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
        input.blur();
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var options = Array.prototype.filter.call(box.querySelectorAll('[data-nv-ps-option]'), function (el) {
        return el.offsetParent !== null;
      });
      if (!options.length) return;
      e.preventDefault();
      var index = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        (options[index + 1] || options[0]).focus();
      } else if (index <= 0) {
        input.focus();
      } else {
        options[index - 1].focus();
      }
    });

    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-nv-search-close]')) {
        close();
        return;
      }

      // Popular searches fill the field and show the suggestions instead of leaving the page
      var chip = e.target.closest('[data-nv-search-chip]');
      if (chip) {
        e.preventDefault();
        input.value = chip.textContent.trim();
        search(input.value);
        input.focus();
        return;
      }

      // "Ajouter": add the single-variant product, then let the theme open its cart drawer
      var add = e.target.closest('[data-nv-ps-add]');
      if (!add) return;
      e.preventDefault();
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.nvPsAdd), quantity: 1 }] })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'add failed');
          add.textContent = 'Ajouté';
          add.classList.add('is-added');
          close();
          if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
            window.Shopify.onItemAdded(data.items ? data.items[0] : data);
          }
        })
        .catch(function () { add.textContent = 'Indisponible'; })
        .then(function () { add.disabled = false; });
    });

    if (!overlay) {
      document.addEventListener('click', function (e) {
        if (!box.contains(e.target)) close();
      });
    }
  }

  function initSearch(root) {
    root.querySelectorAll('nv-search').forEach(initSearchBox);
    if (searchBound) return;
    searchBound = true;

    // Mobile menu drawer: the close button (and the drawer's search button) close it the way
    // Minimog does, with a click on the drawer's own backdrop
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nv-drawer-close]')) return;
      var drawer = document.querySelector('.sf-menu-wrapper-mobile');
      if (drawer) drawer.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nv-search-open]')) return;
      var sheet = document.querySelector('nv-search[data-mode="overlay"]');
      if (!sheet) return;
      e.preventDefault();
      sheet.hidden = false;
      document.documentElement.classList.add('nv-search-locked');
      var field = sheet.querySelector('[data-nv-search-input]');
      if (field) field.focus();
    });
  }

  /* Mega menu extras (product row, universe cards with their best discount) are fetched from
     sections/nv-menu-extras.liquid when a panel or a drawer level opens, not sent with every page */
  var extrasCache = {};
  var extrasBound = false;

  function loadExtras(src) {
    if (!extrasCache[src]) {
      extrasCache[src] = fetch(src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=nv-menu-extras')
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (text) {
          return new DOMParser().parseFromString(text, 'text/html').querySelector('[data-nv-menu-extras]');
        })
        .catch(function () { return null; });
    }
    return extrasCache[src];
  }

  function fillPart(slot, extras, part, title) {
    var node = extras && extras.querySelector('[data-part="' + part + '"]');
    slot.innerHTML = node ? node.innerHTML.trim() : '';
    slot.querySelectorAll('[data-nv-title]').forEach(function (el) { el.textContent = title; });
    slot.classList.add(slot.innerHTML ? 'is-loaded' : 'is-empty');
  }

  function initMenuExtras() {
    if (extrasBound) return;
    extrasBound = true;

    function openPanel(e) {
      var item = e.target.closest && e.target.closest('.sf-menu-item--mega');
      var panel = item && item.querySelector('[data-nv-mm-src]');
      if (!panel || panel.dataset.nvRequested) return;
      panel.dataset.nvRequested = '1';
      loadExtras(panel.dataset.nvMmSrc).then(function (extras) {
        var picks = panel.querySelector('[data-nv-mm-picks]');
        var card = panel.querySelector('[data-nv-mm-card]');
        if (picks) fillPart(picks, extras, 'picks', panel.dataset.nvMmTitle);
        if (card) fillPart(card, extras, 'card', panel.dataset.nvMmTitle);
      });
    }

    document.addEventListener('mouseover', openPanel);
    document.addEventListener('focusin', openPanel);

    // Mobile drawer: fill the universe card when its level opens
    document.addEventListener('click', function (e) {
      var row = e.target.closest('.nv-drawer [data-toggle-submenu="1"]');
      var slot = row && row.closest('.sf-link').querySelector('[data-nv-drawer-card]');
      if (!slot || slot.dataset.nvRequested) return;
      slot.dataset.nvRequested = '1';
      loadExtras(slot.dataset.src).then(function (extras) {
        fillPart(slot, extras, 'drawer-card', slot.dataset.title);
      });
    });
  }

  /* Discount code chip in the hero: copy on click */
  var copyBound = false;

  function initCopyCode() {
    if (copyBound) return;
    copyBound = true;
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-nv-copy]');
      if (!chip) return;
      var label = chip.querySelector('[data-nv-copy-label]');
      var done = function () {
        chip.classList.add('is-copied');
        if (label) label.textContent = 'Copié';
        setTimeout(function () {
          chip.classList.remove('is-copied');
          if (label) label.textContent = 'Copier';
        }, 2000);
      };
      var code = chip.dataset.nvCopy;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {
          if (legacyCopy(code)) done();
        });
      } else if (legacyCopy(code)) {
        done();
      }
    });
  }

  // For browsers or frames where the Clipboard API is refused
  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (err) {
      ok = false;
    }
    document.body.removeChild(area);
    return ok;
  }

  // Swipe rows snap only after the first interaction: a snap during load reads as a scroll to
  // Chrome, which then stops measuring the page's LCP (see .nv-snap in maquette.css)
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
    window.addEventListener(type, function () {
      document.documentElement.classList.add('nv-snap');
    }, { once: true, passive: true });
  });

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-nv-slider]').forEach(initSlider);
    root.querySelectorAll('[data-nv-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-nv-row]').forEach(initRow);
    root.querySelectorAll('[data-nv-boost]').forEach(initBoost);
    root.querySelectorAll('[data-nv-desc]').forEach(initDescription);
    initDrawerShip();
    initCartFeedback();
    initFilters();
    initCopyCode();
    initSearch(root);
    initMenuExtras();
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
